module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "button-bar"
  }, [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": '/clients/' + _vm.currentClientId + '/audits'
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left"
  }), _vm._v(" Back to Client")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": _vm.docUrl
    }
  }, [_c('i', {
    staticClass: "fa fa-file-word-o"
  }), _vm._v(" Audit to Word")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('p', [_vm._v("The audit is \n\t\t\t"), (_vm.audit.locked == 0) ? _c('strong', [_c('i', {
    staticClass: "fa fa-unlock"
  }), _vm._v(" EDITABLE")]) : (_vm.audit.locked == 1) ? _c('strong', [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" LOCKED")]) : (_vm.audit.locked == 1) ? _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.lockUnlockAudit
    }
  }, [_c('i', {
    staticClass: "fa fa-unlock"
  }), _vm._v("\n\t\t\t\tUn-Lock\n\t\t\t")]) : _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.lockUnlockAudit
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v("\n\t\t\t\tLock\n\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "section-toc"
  }, [_c('h2', {
    on: {
      "click": function($event) {
        _vm.tocCollapsed ? _vm.tocCollapsed = false : _vm.tocCollapsed = true
      }
    }
  }, [_vm._v("Sections\n\t\t\t\t\t"), _c('i', {
    staticClass: "fa pull-right",
    class: {
      'fa-caret-up': !_vm.tocCollapsed, 'fa-caret-down': _vm.tocCollapsed
    }
  })]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.tocCollapsed),
      expression: "!tocCollapsed"
    }],
    staticClass: "nav nav-pills nav-stacked"
  }, [_c('li', {
    class: {
      'active': _vm.activeSection == -1
    },
    on: {
      "click": function($event) {
        _vm.activeSection = -1
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Audit Details")])]), _vm._v(" "), _vm._l((_vm.form), function(section, index) {
    return _c('li', {
      class: {
        'active': _vm.activeSection == index
      },
      on: {
        "click": function($event) {
          _vm.activeSection = index
        }
      }
    }, [(section.totalFields - section.totalFieldsAnswered > 0) ? _c('div', {
      staticClass: "alert-bubble",
      attrs: {
        "title": "Unanswered fields"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(section.totalFields - section.totalFieldsAnswered) + "\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(index + 1) + ".0 " + _vm._s(section.heading))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeSection == -1),
      expression: "activeSection == -1"
    }],
    staticClass: "form-section"
  }, [_c('h2', [_vm._v("Audit Details")]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Client",
      "col-class": "col-md-4"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.audit.client_id),
      expression: "audit.client_id"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.audit.client_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.autoSave]
    }
  }, [_c('option', [_vm._v("Select a Client...")]), _vm._v(" "), _vm._l((_vm.clients), function(client) {
    return _c('option', {
      domProps: {
        "value": client.id
      }
    }, [_vm._v(_vm._s(client.company))])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Location",
      "col-class": "col-md-4"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.audit.location_id),
      expression: "audit.location_id"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.audit.location_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.autoSave]
    }
  }, _vm._l((_vm.selectedClientLocations), function(location) {
    return _c('option', {
      domProps: {
        "value": location.id
      }
    }, [_vm._v(_vm._s(location.location_name))])
  }))]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Audit Date",
      "col-class": "col-md-4"
    }
  }, [_c('date-field', {
    on: {
      "change": _vm.autoSave
    },
    model: {
      value: (_vm.audit.audit_date),
      callback: function($$v) {
        _vm.audit.audit_date = $$v
      },
      expression: "audit.audit_date"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.activeSection++
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tNext Section\n\t\t\t\t\t\t"), _c('i', {
    staticClass: "fa fa-arrow-circle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.form), function(section, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index == _vm.activeSection),
        expression: "index == activeSection"
      }],
      staticClass: "form-section"
    }, [(section.heading) ? _c('h2', [_vm._v(_vm._s(index + 1) + ".0 " + _vm._s(section.heading))]) : _vm._e(), _vm._v(" "), (section.fields) ? _c('div', [(_vm.audit.locked == 1) ? _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }]
    }, [_vm._v("The audit is locked, so these fields aren't editable")]) : _vm._e(), _vm._v(" "), _vm._l((section.fields), function(field, fieldIndex) {
      return (_vm.audit.locked == 0) ? _c('audit-field', {
        key: field.question,
        attrs: {
          "label": field.question,
          "field": field,
          "value": field.value
        },
        on: {
          "change": _vm.autoSave,
          "imageFieldChange": function($event) {
            _vm.saveImageFieldChange($event, index, fieldIndex, false)
          }
        }
      }) : _vm._l((section.fields), function(field, fieldIndex) {
        return _c('form-group', {
          key: field.question,
          attrs: {
            "label": field.question,
            "col-class": "col-md-6"
          }
        }, [(field.type == 'images') ? _c('image-upload-field', {
          attrs: {
            "images": field.value,
            "locked": true,
            "api-base": _vm.apiBase
          }
        }) : _c('div', {
          staticClass: "form-control-plaintext"
        }, [_c('div', {
          staticClass: "field-text-answer"
        }, [_vm._v(_vm._s(field.value))])]), _vm._v(" "), (field.hasNotes) ? _c('strong', [_vm._v("Notes:")]) : _vm._e(), _vm._v(" "), (field.hasNotes) ? _c('div', {
          staticClass: "form-control-plaintext"
        }, [_vm._v(_vm._s(field.notes))]) : _vm._e(), _vm._v(" "), _c('hr')], 1)
      })
    })], 2) : _vm._e(), _vm._v(" "), _vm._l((section.subSections), function(subSection, subindex) {
      return (section.subSections) ? _c('div', {
        staticClass: "form-subsection"
      }, [(subSection.heading) ? _c('h3', [_vm._v(_vm._s(index + 1) + "." + _vm._s(subindex + 1) + " " + _vm._s(subSection.heading))]) : _vm._e(), _vm._v(" "), (subSection.fields) ? _c('div', [(_vm.audit.locked == 1) ? _c('p', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (false),
          expression: "false"
        }]
      }, [_vm._v("The audit is locked, so these fields aren't editable")]) : _vm._e(), _vm._v(" "), _vm._l((subSection.fields), function(field, fieldIndex) {
        return (_vm.audit.locked == 0) ? _c('audit-field', {
          key: field.question,
          attrs: {
            "label": field.question,
            "field": field,
            "value": field.value
          },
          on: {
            "change": _vm.autoSave,
            "imageFieldChange": function($event) {
              _vm.saveImageFieldChange($event, index, fieldIndex, true)
            }
          }
        }) : _vm._l((subSection.fields), function(field, fieldIndex) {
          return _c('form-group', {
            key: field.question,
            attrs: {
              "col-class": "col-md-6",
              "label": field.question
            }
          }, [(field.type == 'images') ? _c('image-upload-field', {
            attrs: {
              "images": field.images,
              "locked": true,
              "api-base": _vm.apiBase
            }
          }) : _c('div', {
            staticClass: "form-control-plaintext"
          }, [_c('div', {
            staticClass: "field-text-answer"
          }, [_vm._v(_vm._s(field.value))])]), _vm._v(" "), (field.hasNotes) ? _c('strong', [_vm._v("Notes:")]) : _vm._e(), _vm._v(" "), (field.hasNotes) ? _c('div', {
            staticClass: "form-control-plaintext"
          }, [_vm._v(_vm._s(field.notes))]) : _vm._e()], 1)
        })
      }), _vm._v(" "), _c('hr')], 2) : _vm._e()]) : _vm._e()
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.activeSection--
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrow-circle-left"
    }), _vm._v("\n\t\t\t\t\t\tPrevious Section\n\t\t\t\t\t")]), _vm._v(" "), (_vm.form.length > index + 1) ? _c('button', {
      staticClass: "btn btn-default pull-right",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.activeSection++
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\tNext Section\n\t\t\t\t\t\t"), _c('i', {
      staticClass: "fa fa-arrow-circle-right"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })], 2)
  })], 2)])]), _vm._v(" "), (_vm.confirmDialog.visible) ? _c('modal-dialog', {
    attrs: {
      "title": "Mark Task as Completed",
      "modal-visible": _vm.confirmDialog.visible,
      "confirm-button-text": "Yes",
      "button-class": "btn-primary"
    },
    on: {
      "confirm": _vm.completeTask,
      "closeModal": function($event) {
        _vm.confirmDialog.visible = false
      }
    }
  }, [_vm._v("\n        You've completed your audit form! Would you like to mark the linked task as complete?\n    ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-126734aa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AuditForm.vue
// module id = 267
// module chunks = 0